const piwikPrefix = 'kreditt-boliglaanskalkulator';

const formaterPiwikName = (name: string): string => {
    let lowercase = name.toLowerCase();
    lowercase = lowercase.replace(/å/g, 'aa');
    lowercase = lowercase.replace(/ø/g, 'oe');
    lowercase = lowercase.replace(/æ/g, 'ae');
    lowercase = lowercase.replace(/ /g, '-');
    lowercase = lowercase.replace(/\?/, '');
    lowercase = lowercase.replace(/!/, '');
    return lowercase;
};

export const piwikTrackId = (trackId: string) => formaterPiwikName(`${piwikPrefix}-${trackId}`);

export const piwikTrackName = (trackname: string) => formaterPiwikName(`${trackname}`);
